const formatContentValue = (value, type) => {
  if (type !== 'social') {
    return value
  }
  return value.replace(' ', '').trim()
}

export default formatContentValue
